// extracted by mini-css-extract-plugin
var _1 = "xk51Qt8xo1WNMo5xJi8P";
export { _1 as "root" }
